import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AliasService } from '../../services/alias.service';
import { ClientService } from '../../services/client.service';
import { IndexService } from '../../services/index.service';
import { NotificationService } from '../../services/notification.service';
import { BreadcrumbsComponent } from '../../shared/breadcrumbs/breadcrumbs.component';
import { ConfirmModalComponent } from '../../shared/confirm-modal/confirm-modal.component';
import { ModalComponent } from '../../shared/modal/modal.component';
import { SharedTableComponent } from '../../shared/shared-table/shared-table.component';


@Component({
  selector: 'app-alias-detail',
  imports: [MatCardModule, MatTabsModule, SharedTableComponent, MatIconModule, BreadcrumbsComponent],
  templateUrl: './alias-detail.component.html',
  styleUrl: './alias-detail.component.scss'
})
export class AliasDetailComponent implements OnInit, OnDestroy {

  id: string | null = null;
  name: string | null = null;
  sortBy = '';
  sortField = '';
  sortDirection = '';
  searchQuery: string = '';
  activeTab: string = '';
  isLoading = false;

  singleAliasElement: any = {};

  dataSourceMeta = new MatTableDataSource();
  dataSourceIndex = new MatTableDataSource();
  dataSourcePattern = new MatTableDataSource();

  // Paginazione client-side della tabella index
  indexPageIndex = 0;
  indexPageSize = 10;
  indexTotalItems = 0;

  // Paginazione client-side della tabella pattern
  patternPageIndex = 0;
  patternPageSize = 10;
  patternTotalItems = 0;

  // Paginazione client-side della tabella fields
  fieldPageIndex = 0;
  fieldPageSize = 10;
  fieldTotalItems = 0;

  pagedDataIndex: any[] = [];
  pagedDataPattern: any[] = [];
  pagedDataField: any[] = [];
  
  //configurazione modale a seconda del tab attivo
  tableConfigs: Record<string, {
    visibleFields: string[],
    readonlyFields?: {edit?: string[], add?: string[], delete?: string[]},
    labels: Record<string,string>,
    fieldTypes: Record<string,string>,
    selectOptions?: Record<string, {value: any, label: string}[]>,
    loadingSelect?: Record<string, boolean>
    errorSelect?: Record<string, boolean>
  }> = {
    meta: {
      visibleFields: ['fieldId', 'value', 'type'],
      readonlyFields: {
        edit: ['fieldId']
      },
      labels: {
        fieldId: 'Field',
        value: 'Testo/Regex',  
        type: 'Azione da eseguire',
      },
      fieldTypes: {
        fieldId: 'select',
        textRegex: 'input',
        type: 'select'
      },
      selectOptions: {
        fieldId: [{
          value: '',
          label: ''
        }],
        type: [
        {
          value: 'INCLUDE',
          label: 'Includi'
        },
        {
          value: 'EXCLUDE',
          label: 'Escludi'
        },
      ]
      },
      loadingSelect: {
        fieldId: false
      },
      errorSelect: {
        fieldId: false
      }
    },
    index: {
      visibleFields: ['name'],
      labels: {
        name: 'Nome',
      },
      fieldTypes: {
        name: 'select'
      },
       selectOptions: {
        name: [{
          value: '',
          label: ''
        }]
      },
      loadingSelect: {
        name: false
      },
      errorSelect: {
        name: false
      }
    },
    pattern: {
      visibleFields: ['pattern', 'type'],
      readonlyFields: {
        edit: ['pattern']
      },
      labels: {
        pattern: 'Pattern',
        type: 'Azione da eseguire',
      },
      fieldTypes: {
        pattern: 'input',
        type: 'select'
      },
       selectOptions: {
        type: [
        {
          value: 'INCLUDE',
          label: 'Includi'
        },
        {
          value: 'EXCLUDE',
          label: 'Escludi'
        },
      ]
      }
    }

  }

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private readonly aliasService: AliasService, private readonly clientService: ClientService, private readonly dialog: MatDialog, private readonly indexService: IndexService, private readonly notificationService: NotificationService){}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get('id');
      const encodedName = params.get('name');
      this.name = encodedName ? decodeURIComponent(encodedName) : null;
    });

    const stored = localStorage.getItem('selectedAliasRow');
    if(stored){
      this.singleAliasElement = JSON.parse(stored);
      console.log('dato singolo', this.singleAliasElement);
    }

    this.activeTab = 'index';

     if(this.id){
      this.loadMetaList();
      this.loadPatternList();
      this.loadIndexList();
    
    }

    console.log("tabAttiva", this.activeTab);
    
  }

  //lista di meta associati all'alias
  loadMetaList(){
     this.dataSourceMeta.data = this.singleAliasElement.aliasFields;
     this.fieldTotalItems = this.singleAliasElement.aliasFields.length ?? 0;
     this.updatePage();
     console.log('meta list data', this.dataSourceMeta.data);
    
  }
 //lista di patterns associati all'alias
  loadPatternList(){
    this.dataSourcePattern.data = this.singleAliasElement.aliasPatterns;
    this.patternTotalItems = this.singleAliasElement.aliasPatterns.length ?? 0;
    this.updatePage();
    console.log('patterns list data', this.dataSourcePattern.data);
  }
 //lista di indici associati all'alias
  loadIndexList(){
    this.dataSourceIndex.data = this.singleAliasElement.indexes;
    this.indexTotalItems = this.singleAliasElement.indexes.length ?? 0;
    this.updatePage();
    console.log('indexes list data', this.dataSourceIndex.data);
  }

  onTabChanged(event: MatTabChangeEvent){
    switch(event.index){
      case 0: 
        this.activeTab = 'index';
        break;
      case 1:
        this.activeTab = 'pattern';
        break;
      case 2:
        this.activeTab = 'meta';
        break;
      default:
        this.activeTab = '';
    }
  }


  onSortChanged(sort: Sort){
    console.log('sort', sort);
  }

  // Cambio pagina / page size (client-side)
  onPageChanged(ev: PageEvent) {
    if(this.activeTab === 'index'){
      this.indexPageIndex = ev.pageIndex;
      this.indexPageSize  = ev.pageSize;
    }
    if(this.activeTab === 'pattern'){
      this.patternPageIndex = ev.pageIndex;
      this.patternPageSize  = ev.pageSize;
    }
    if(this.activeTab === 'meta'){
      this.fieldPageIndex = ev.pageIndex;
      this.fieldPageSize  = ev.pageSize;
    } 
    
    this.updatePage();
  }

  private updatePage(){
    
    if(this.activeTab === 'index'){
      const start = this.indexPageIndex * this.indexPageSize;
      const end = start + this.indexPageSize;
      this.pagedDataIndex = this.dataSourceIndex.data.slice(start, end);
    }
    if(this.activeTab === 'pattern'){
      const start = this.patternPageIndex * this.patternPageSize;
      const end = start + this.patternPageSize;
      this.pagedDataPattern = this.dataSourcePattern.data.slice(start, end);
    }
    if(this.activeTab === 'meta'){
      const start = this.fieldPageIndex * this.fieldPageSize;
      const end = start + this.fieldPageSize;
      this.pagedDataField = this.dataSourceMeta.data.slice(start, end);
    } 
    
  }

  private enableFieldIfNeeded(modalIInstance: any, config: any, fieldKey: string, action?: string ){
    if(modalIInstance?.formData){
      const isReadonlyInEdit = config.readonlyFields?.edit?.includes(fieldKey) && action === 'edit';

      if(!isReadonlyInEdit){
        modalIInstance.formData.get(fieldKey)?.enable();
      }
    }
  }

  getSelectOptionsForModal(tab: string, modalIInstance?: any, action?: string){
      const config = this.tableConfigs[tab];
      if(tab === 'meta'){
        config.loadingSelect!['fieldId'] = true;
        config.errorSelect!['fieldId'] = false;

        this.clientService.getAllFields().subscribe({
          next: (response) => {
            //aggiorno le opzioni dinamiche del config 
            console.log('meta options', response);
            console.log('meta options è un array', Array.isArray(response));
            const metaOptions = response as Array<{value: string; label: string; system: boolean}>;
            if(config.selectOptions){
              config.selectOptions['fieldId'] = metaOptions.filter((x:any) => x.system === false).map((x:any) => ({
                value: x.id,
                label: x.name
              }))
            }
            config.loadingSelect!['fieldId'] = false;

            //metodo centralizzato per gestire l'abilitazione dei campi
            this.enableFieldIfNeeded(modalIInstance, config, 'fieldId', action);

          },
          error: () => {
            config.selectOptions!['fieldId'] = [];
            config.loadingSelect!['fieldId'] = false;
            config.errorSelect!['fieldId'] = true;
          } 
          
        });
      } 
      if(tab === 'index'){
        config.loadingSelect!['name'] = true;
        config.errorSelect!['name'] = false;

        this.indexService.getAllIndexes().subscribe({
          next: (response) => {
            //aggiorno le opzioni dinamiche del config 
            console.log('index options', response);
            console.log('index options è un array', Array.isArray(response));
            const indexOptions = response as Array<{value: string; label: string}>;
            if(config.selectOptions){
              config.selectOptions['name'] = indexOptions.map((x:any) => ({
                value: x.id,
                label: x.name
              }))
            }
            config.loadingSelect!['name'] = false;

            //metodo centralizzato per gestire l'abilitazione dei campi
            this.enableFieldIfNeeded(modalIInstance, config, 'name', action);
          },
          error: () => {
            config.selectOptions!['name'] = [];
            config.loadingSelect!['name'] = false;
            config.errorSelect!['name'] = true;
          }
          
        });
      }
    }
  
    openDialog(event : {data: any, type: 'add' | 'edit' | 'delete'}){
        
        const activatedTab = this.activeTab;
        console.log('tab attivo', activatedTab); 
        const config  = this.tableConfigs[activatedTab];
        
  
        const dialogRef = this.dialog.open(ModalComponent, {
          width: '400px',
          data: {
            action: event.type,
            payload: event.data,
            visibleFields: config.visibleFields,
            readonlyFields: config.readonlyFields,
            labels: config.labels,
            fieldTypes: config.fieldTypes, // tipologia dei campi contenuti in modale
            selectOptions: config.selectOptions, // se presente un campo di tipo select, le opzioni della select
            loadingSelect: config.loadingSelect,
            errorSelect: config.errorSelect
          } 
        });

        this.getSelectOptionsForModal(activatedTab, dialogRef.componentInstance, event.type);
    
        dialogRef.afterClosed().subscribe(result => {
          console.log('result', result);
          if(result){
            this.isLoading = true;
            //caso meta 
            if(activatedTab === 'meta'){
              if(event.type === 'add') {
                // se l'id del meta da aggiungere è già presente in lista, non deve essere effettuata la chiamata
                const index = this.dataSourceMeta.data.findIndex( (el: any) =>  el.fieldId === result.fieldId);

                if(index !== -1){
                  this.isLoading = false;
                  this.dialog.open(ConfirmModalComponent, {
                    width: '400px',
                    data: {
                      message: "Un meta con lo stesso ID è già stato associato.",
                      title: 'Attenzione'
                    }
                  });
                  return;
                }

                const payload = {...result};
                const aliasId = this.id!;
                
                this.aliasService.addOrUpdateFieldToAlias(payload, aliasId).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  
                  this.singleAliasElement.aliasFields = response.aliasFields;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('add', 'Field');
                  this.loadMetaList();
                  
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('add', 'Field');
                }
              });
              
            } else if (event.type === 'edit') {
              console.log('modifica');
              const index = this.dataSourceMeta.data.findIndex( (el: any) =>  el.fieldId === result.fieldId);
              
              const payload = {...result};
              const aliasId = this.id!;

              if (index !== -1){
                this.aliasService.addOrUpdateFieldToAlias(payload, aliasId).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  
                  this.singleAliasElement.aliasFields = response.aliasFields;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('update', 'Field');
                  this.loadMetaList();
                  
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('update', 'Field');
                }
              });
                
              } 
            } else if (event.type === 'delete'){
              console.log('disassocia');
              console.log('result delete', result);
              this.aliasService.removeFieldFromAlias(result.aliasId, result.fieldId).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  this.singleAliasElement.aliasFields = response.aliasFields;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('delete', 'Field');
                  this.loadMetaList();
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('delete', 'Field');
                }
              });
            } 
          }
          //caso index
          if(activatedTab === 'index'){
            if(event.type === 'add') {
              // se l'id dell'indice da aggiungere è già presente in lista, non deve essere effettuata la chiamata
                const index = this.dataSourceIndex.data.findIndex( (el: any) =>  el.id === result.name);
                if(index !== -1){
                  this.isLoading = false;
                  this.dialog.open(ConfirmModalComponent, {
                    width: '400px',
                    data: {
                      message: 'Un indice con lo stesso ID è già stato associato.',
                      title: 'Attenzione'
                    }
                  });
                  return;
                }
                console.log('risultato add index', result);
                const payload = {...result};
                const aliasId = this.id!;
                
                this.aliasService.addIndexToAlias(aliasId, payload.name).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  
                  this.singleAliasElement.indexes = response.indexes;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('add', 'Index');
                  this.loadIndexList();
                  
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('add', 'Index');
                }
              });
              
            } else if (event.type === 'delete'){
              console.log('disassocia');
              console.log('result index delete', result);
              const aliasId = this.id!;
              this.aliasService.removeIndexFromAlias(aliasId, result.id).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  this.singleAliasElement.indexes = response.indexes;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('delete', 'Index');
                  this.loadIndexList();
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('delete', 'Index');
                }
              });
            } 
          }
          //caso pattern
          if(activatedTab === 'pattern'){
            if(event.type === 'add') {
              // se il pattern da aggiungere è già presente in lista, non deve essere effettuata la chiamata
                const index = this.dataSourcePattern.data.findIndex( (el: any) =>  el.pattern === result.pattern);
                if(index !== -1){
                  this.isLoading = false;
                  this.dialog.open(ConfirmModalComponent, {
                    width: '400px',
                    data: {
                      message: "Lo stesso pattern è già stato associato.",
                      title: 'Attenzione'
                    }
                  });
                  return;
                }
                console.log('risultato add pattern', result);
                const payload = {...result};
                const aliasId = this.id!;
                
                this.aliasService.addOrUpdatePatternToAlias(payload, aliasId).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  
                  this.singleAliasElement.aliasPatterns = response.aliasPatterns;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('add', 'Pattern');
                  this.loadPatternList();
                  
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('add', 'Pattern');
                }
              });
              
            } else if (event.type === 'edit') {
              console.log('modifica');
              const index = this.dataSourcePattern.data.findIndex( (el: any) =>  el.id === result.id);
              const payload = {...result};
              const aliasId = this.id!;
              
              if (index !== -1){
                this.aliasService.addOrUpdatePatternToAlias(payload, aliasId).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  
                  this.singleAliasElement.aliasPatterns = response.aliasPatterns;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('update', 'Pattern');
                  this.loadPatternList();
                  
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('update', 'Pattern');
                }
              });
                
              } 
            } else if (event.type === 'delete'){
              console.log('disassocia');
              console.log('result delete pattern', result);
              this.aliasService.removePatternFromAlias(result.aliasId, result.id).pipe(finalize(() => { this.isLoading = false; })).subscribe({
                next: (response) => {
                  this.singleAliasElement.aliasPatterns = response.aliasPatterns;
                  localStorage.setItem('selectedAliasRow', JSON.stringify(response));
                  this.notificationService.entitySuccess('delete', 'Pattern');
                  this.loadPatternList();
                },
                error: (err) => {
                  console.log("errore nella richiesta", err);
                  this.notificationService.entityError('delete', 'Pattern');
                }
              });
            } 
          }
  
          } 
            
         });
      }

      ngOnDestroy(): void {
      localStorage.removeItem('selectedAliasRow');
    }

}
